import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";
var _class, _descriptor, _descriptor2, _descriptor3;
import { computed, flow, observable, runInAction, set } from "mobx";
import { LicenseActivation } from ".";
import { realCommerceRequest } from "../utils";
import { RealCommerceError } from "../exceptions";
import { routeLocationLicensePatch, routeLocationLicenseDelete, routeLocationLicenseActivationsGet } from "@devowl-wp/api-real-commerce";
let License = (_class = class License {
  get subscription() {
    const {
      subscription
    } = this.data;
    return subscription ? this.store.subscriptions.get(subscription.id) : undefined;
  }
  constructor(_data, store) {
    _initializerDefineProperty(this, "data", _descriptor, this);
    _initializerDefineProperty(this, "busy", _descriptor2, this);
    _initializerDefineProperty(this, "activations", _descriptor3, this);
    this.store = void 0;
    // eslint-disable-next-line @typescript-eslint/member-ordering
    this.update = flow(function* (data) {
      this.busy = true;
      yield this.store.probablyRenewJwt();
      try {
        const {
          license: newData
        } = yield realCommerceRequest({
          location: routeLocationLicensePatch,
          request: {
            license: {
              licenseKey: this.data.licenseKey,
              ...data
            }
          },
          settings: {
            headers: this.store.authorizationHeader
          }
        });
        this.data = newData;

        // Recalculate "Products" so "usage / maxUsage" count is corrected
        this.store.fetchSubscriptions();
      } catch (e) {
        console.log(e);
        throw new RealCommerceError(e);
      } finally {
        this.busy = false;
      }
    });
    // eslint-disable-next-line @typescript-eslint/member-ordering
    this.delete = flow(function* () {
      this.busy = true;
      yield this.store.probablyRenewJwt();
      try {
        yield realCommerceRequest({
          location: routeLocationLicenseDelete,
          request: {
            license: {
              licenseKey: this.data.licenseKey
            }
          },
          settings: {
            headers: this.store.authorizationHeader
          }
        });
        this.store.licenses.delete(this.data.id);

        // Recalculate "Products" so "usage / maxUsage" count is corrected
        this.store.fetchSubscriptions();
      } catch (e) {
        console.log(e);
        throw new RealCommerceError(e);
      } finally {
        this.busy = false;
      }
    });
    // eslint-disable-next-line @typescript-eslint/member-ordering
    this.fetchActivations = flow(function* () {
      this.busy = true;
      yield this.store.probablyRenewJwt();
      try {
        const {
          licenseActivations
        } = yield realCommerceRequest({
          location: routeLocationLicenseActivationsGet,
          params: {
            licenseKey: this.data.licenseKey
          },
          settings: {
            headers: this.store.authorizationHeader
          }
        });
        for (const row of licenseActivations) {
          const {
            id
          } = row;
          const existing = this.activations.get(id);
          if (existing) {
            set(existing.data, row);
          } else {
            this.activations.set(id, new LicenseActivation(row, this));
          }
        }

        // Remove stale subscriptions
        const activeIds = licenseActivations.map(_ref => {
          let {
            id
          } = _ref;
          return id;
        });
        Array.from(this.activations.keys()).forEach(potentialStaleId => {
          if (activeIds.indexOf(potentialStaleId) === -1) {
            this.activations.delete(potentialStaleId);
          }
        });
      } catch (e) {
        console.log(e);
        throw new RealCommerceError(e);
      } finally {
        this.busy = false;
      }
    });
    this.store = store;
    runInAction(() => {
      this.data = _data;
    });
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "data", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "busy", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "activations", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return new Map();
  }
}), _applyDecoratedDescriptor(_class.prototype, "subscription", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "subscription"), _class.prototype)), _class);
export { License };